import { ResourceReleaseNotesQueryParams } from '@/api/apis/resources/release-notes';

export const resourceReleaseNotesQueryKeys = {
  all: (product: string) => ['resource-release-notes', product] as const,
  list: (product: string, params?: ResourceReleaseNotesQueryParams) =>
    ['resource-release-notes', product, 'list', params] as const,
};
